module.exports = __webpack_public_path__ + "img/case8.2d3ee128.jpg";